import React, {useState} from 'react';
import {
    AddLink,
    ArrowCircleLeft,
    CompareArrows, Create,
    Delete,
    EmergencyRecording,
    EmergencyRecordingOutlined,
    EmergencyRecordingRounded,
    EmergencyRecordingTwoTone,
    FiberManualRecord,
    FiberSmartRecord, Link,
    LinkedCamera, LinkRounded,
    MissedVideoCall,
    MusicVideo,
    OndemandVideo, OpenInBrowser,
    PersonalVideo, ScatterPlot, Schema,
    SettingsInputSvideo,
    SlowMotionVideo, SubdirectoryArrowLeft,
    SwitchVideo, Videocam,
    VideoCameraBack,
    VideoCameraFront,
    VideoChat, VideoLabel, VideoLibrary, VideoStable
} from '@mui/icons-material';
import {CircularProgress, IconButton} from '@mui/material';
import {Box, Button, AppBar, Toolbar, Grid, Typography, Modal, LinearProgress, TextField} from '@mui/material';
import {
    Add, Edit
} from '@mui/icons-material';
import ConfirmEmailMessage from "./ConfirmEmailMessage";
import RecordingEditor from "./RecordingEditor";
import {
    closestCenter,
    DndContext,
    DragEndEvent,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    useSortable,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';
import {stopPropagation} from "@dnd-kit/core/dist/sensors/events";

import {Slide} from '../services/types'
import {Links} from "react-router-dom";
import {fetchProducts, generateVisit} from "../services/api";

interface VisitSlide {
    id: string;
    slide: Slide;
}

interface Visit {
    id: string;
    name: string;
    is_default: boolean;
    mcd_nonprescriber: string;
    mcd_trialist: string;
    mcd_user: string;
    mcd_advocate: string;
    endo_nonprescriber: string;
    endo_trialist: string;
    endo_user: string;
    endo_advocate: string;
    obstetrics_nonprescriber: string;
    obstetrics_trialist: string;
    obstetrics_user: string;
    obstetrics_advocate: string;
    peri_nonprescriber: string;
    peri_trialist: string;
    peri_user: string;
    peri_advocate: string;
    post_nonprescriber: string;
    post_trialist: string;
    post_prescriber: string;
    post_advocate: string;
    project_id: string;
    sort: number;
    external_id?: string;
    slides: VisitSlide[];
}

interface VisitBoxProps {
    visit: Visit;
    onAddSlide: (visitId: string) => void;
    onEditName: (visitId: string,
                 visitName: string,
                 visitIsDefault: boolean,
                 visitMCDNonprescriber:string,
                 visitMCDTrialist:string,
                 visitMCDUser:string,
                 visitMCDAdvocate:string,
                 visitEndoNonprescriber:string,
                 visitEndoTrialist:string,
                 visitEndoUser:string,
                 visitEndoAdvocate:string,
                 visitoObstetricsNonprescriber:string,
                 visitObstetricsTrialist:string,
                 visitObstetricsUser:string,
                 visitObstetricsAdvocate:string,
                 visitoPeriNonprescriber:string,
                 visitPeriTrialist:string,
                 visitPeriUser:string,
                 visitPeriAdvocate:string,
                 visitoPostNonprescriber:string,
                 visitPostTrialist:string,
                 visitPostPrescriber:string,
                 visitPostAdvocate:string
    ) => void;
    onDeleteVisit: (visitId: string) => void;
    onReorderSlides: (visitId: string, newOrder: string[]) => void;
    onDeleteSlide: (visitSlideId: string) => void;
}
interface SortableSlideItemProps {
    slide: VisitSlide;
    onDelete: (visitSlideId: string) => void;
}
const VisitBox: React.FC<VisitBoxProps> = ({visit, onAddSlide, onEditName, onDeleteVisit, onReorderSlides, onDeleteSlide}) => {
    const [isDragging, setIsDragging] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingVisitId, setRecordingVisitId] = useState("");
    const [recordingVisitSlides, setRecordingVisitSlides] = useState<VisitSlide[]>([]);
    const [isGenerateModalOpen, setIsGenerateModalOpen] = useState(false);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    const handleDragMove = (event: DragEndEvent) => {
        setIsDragging(true);
    };
    const handleDragEnd = (event: DragEndEvent) => {
        setIsDragging(false);

        const {active, over} = event;
        if (over && active.id !== over.id) {
            const oldIndex = visit.slides.findIndex((slide) => slide.id === active.id);
            const newIndex = visit.slides.findIndex((slide) => slide.id === over.id);
            const newOrder = arrayMove(visit.slides, oldIndex, newIndex);
            onReorderSlides(visit.id, newOrder.map(slide => slide.id));
        }
    };

    const generateVisitFunc = async (visitId: string) => {
        try {
            setIsGenerateModalOpen(true)
            await generateVisit(visitId)
            setIsGenerateModalOpen(false)
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }

    };

    const openRecordModal = (visitId: string, slides: VisitSlide[]) => {
        setRecordingVisitId(visitId)
        setRecordingVisitSlides(slides)

        setIsRecording(true)
    };
    const closeRecording = () => {
        setRecordingVisitId("")
        setRecordingVisitSlides([])
        setIsRecording(false)
    };



    const SortableSlideItem: React.FC<SortableSlideItemProps> = ({ slide, onDelete }) => {
        const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: slide.id });


        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
        };
        const handleDelete = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (!isDragging) {
                onDelete(slide.id);
            }
        };
        return (
            <Box
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className='visitSlideItem'
                sx={{
                    position: 'relative',
                    '&:hover .deleteButton': {opacity: 1}
                }}
            >
                <img src={slide.slide.preview} alt={slide.slide.name} />

                <IconButton
                    className="deleteButton"
                    sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onMouseUp={(e) => {e.stopPropagation(); handleDelete(e);}}
                    // onClick={handleDelete}
                >
                    <Delete/>
                </IconButton>
            </Box>
        );
    };

    return (

        <>
            <Box mb={4} sx={{pr: '12px'}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography variant="h6">{visit.name}</Typography>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => onEditName(
                            visit.id,
                            visit.name,
                            visit.is_default,
                            visit.mcd_nonprescriber,
                            visit.mcd_trialist,
                            visit.mcd_user,
                            visit.mcd_advocate,
                            visit.endo_nonprescriber,
                            visit.endo_trialist,
                            visit.endo_user,
                            visit.endo_advocate,
                            visit.obstetrics_nonprescriber,
                            visit.obstetrics_trialist,
                            visit.obstetrics_user,
                            visit.obstetrics_advocate,
                            visit.peri_nonprescriber,
                            visit.peri_trialist,
                            visit.peri_user,
                            visit.peri_advocate,
                            visit.post_nonprescriber,
                            visit.post_trialist,
                            visit.post_prescriber,
                            visit.post_advocate
                        )}>
                            <Edit/>
                        </Button>
                        {visit.slides.length == 0 ?
                            <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}} onClick={() => onDeleteVisit(visit.id)}>
                                <Delete/>
                            </Button>
                            : null
                        }
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
                        {/*<Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => openRecordModal(visit.id, visit.slides)}>*/}
                        {/*    <Videocam/>*/}
                        {/*</Button>*/}
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => generateVisitFunc(visit.id)}>
                            Сгенерировать
                        </Button>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', ml: 2}} onClick={() => {window.open('https://static.productscript.ru/web/?v='+visit.id, '_blank');}}>
                            <OpenInBrowser/>
                        </Button>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}} onClick={() => onAddSlide(visit.id)}>
                            <Add/> Добавить слайд
                        </Button>
                    </Box>
                </Box>
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd} onDragMove={handleDragMove}>
                    <SortableContext items={visit.slides.map(slide => slide.id)} strategy={verticalListSortingStrategy}>
                        <Box className='visitSlideItems'>
                            {visit.slides.map((slideitem) => (
                                <SortableSlideItem key={slideitem.id} slide={slideitem} onDelete={() => onDeleteSlide(slideitem.id)} />
                            ))}
                        </Box>
                    </SortableContext>
                </DndContext>
            </Box>

            {/* Модальное окно загрузки */}
            <Modal open={isGenerateModalOpen} onClose={() => setIsGenerateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography>Идет обработка...</Typography>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/*{isRecording && (*/}
            {/*    <RecordingEditor*/}
            {/*        id={recordingVisitId}*/}
            {/*        slides={recordingVisitSlides}*/}
            {/*        closeRecording={closeRecording}*/}
            {/*    />*/}
            {/*)}*/}
        </>

    );
};
export default VisitBox;
